import facebookLogo from "../assets/img/platform_logos/facebook.svg";
import instagramLogo from "../assets/img/platform_logos/instagram.webp";
import kickLogo from "../assets/img/platform_logos/kick.svg";
import tiktokLogo from "../assets/img/platform_logos/tiktok.webp";
import twitchLogo from "../assets/img/platform_logos/twitch.webp";
import vimeoLogo from "../assets/img/platform_logos/vimeo.webp";
import youtubeLogo from "../assets/img/platform_logos/youtube.webp";

/**
 * Get the logo for a given platform
 * @param {string} platform - The platform name (e.g., "youtube", "tiktok", "twitch", etc.)
 * @returns {string} The logo image path for the platform
 */
export const getPlatformLogo = (platform) => {
  switch (platform) {
    case "youtube":
      return youtubeLogo;
    case "tiktok":
      return tiktokLogo;
    case "twitch":
      return twitchLogo;
    case "vimeo":
      return vimeoLogo;
    case "instagram":
      return instagramLogo;
    case "facebook":
      return facebookLogo;
    case "kick":
      return kickLogo;
    default:
      return youtubeLogo;
  }
};
